<script setup lang="ts">
import emblaCarouselVue from 'embla-carousel-vue'

defineProps({ blok: Object })

const [emblaRef, emblaApi] = emblaCarouselVue({ loop: false })
const selectedSlide = ref<number | string>(0)

onMounted(() => {
    if (emblaApi.value) emblaApi.value.on('select', () => {
        selectedSlide.value = emblaApi.value?.selectedScrollSnap() ?? ''
    })
    if (emblaApi.value) emblaApi.value.on('init', () => {
        selectedSlide.value = emblaApi.value?.selectedScrollSnap() ?? ''
    })
})
</script>

<template>
    <section
        :class="[
            'story__blok story__blok--column-image',
            {
                'bg-chsc-raw': blok?.background,
            },
        ]"
    >
        <UiContainer
            :max-width="blok?.container_width"
        >
            <div
                ref="emblaRef"
                :class="[
                    'embla relative',
                    { 'rounded-[40px]': blok?.container_width != 'max-w-full' },
                ]"
            >
                <div class="embla__container">
                    <div
                        v-for="(item, index) in blok?.images"
                        :key="index"
                        class="embla__slide aspect-video"
                    >
                        <img
                            v-if="item"
                            class="w-full h-full object-cover"
                            :src="item.filename"
                            :alt="item.alt || ''"
                        >
                    </div>
                </div>
                <div
                    v-if="blok?.images.length > 1"
                    class="embla__dots z-10"
                >
                    <button
                        v-for="(item, index) in blok?.images"
                        :key="index"
                        :class="[
                            'embla__dot',
                            {
                                'embla__dot--active': selectedSlide === index,
                            },
                        ]"
                        @click="emblaApi?.scrollTo(index)"
                    />
                </div>
                <div
                    v-if="blok?.overlay_text"
                    class="w-full h-full absolute top-0 left-0 flex items-center justify-center"
                >
                    <div class="w-full h-full absolute top-0 left-0 bg-black/50" />
                    <UiContainer max-width="max-w-2xl">
                        <div class="relative text-white text-center fs-6xl font-eb-garamond">
                            {{ blok?.overlay_text }}
                        </div>
                    </UiContainer>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
